import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Divider = styled.div.withConfig({
  shouldForwardProp,
})<MarginProps>`
  width: 100%;
  height: 1px;
  background-color: ${themeGet('colors.line.tertiary')};

  ${margin}
`
